import { eventSearchReducer, searchReducer } from '@eventbrite/search-utils';
import { combineReducers } from 'redux';

const eventSearch = combineReducers(eventSearchReducer);

export default combineReducers({
    ...searchReducer,
    eventSearch,
});
